module.exports = __webpack_public_path__ + "static/media/10.0d75770a.jpg";